/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { format, subDays } from 'date-fns';

import { cpfOrCnpjMask } from '../masks';
import { luftGet } from '../../../../../shared/http';

import NFFilter from '../components/FilterContainer';
import FilterForm from '../components/FilterForm';
import CheckboxControl from '../components/CheckboxControl';
import InfinityContent from '../components/InfinityContent';
import debounce from 'lodash.debounce';
import { useCallback } from 'react';
import { useMemo } from 'react';

const Customers = ({ isOpen, onClick, onApply, listCustomers, initialPeriod, finalPeriod, byDate }) => {
  const [selectedItem, setSelectedItem] = useState(listCustomers);
  const [atualPage, setAtualPage] = useState(1);
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [queryParamas, setQueryParams] = useState();

  useEffect(() => {
    if(listCustomers?.length < 1) {
      setSelectedItem([]);
    }
  }, [listCustomers]);

  const totalLines = data[0] && data[0].totalLines;

  const companyId =
    window.localStorage.getItem('Luft/CustomerService/CompanyId') || window.localStorage.getItem('Luft/CompanyId');

  const params = {
    initialPeriod,
    finalPeriod,
    byDate,
    page: atualPage,
    amount: 10,
    companyId,
  };

  const fetchAllCustomer = async () => {
    if (loading) {
      return;
    }
    try {
      setLoading(true);

      const response = await luftGet(
        '/IntegratedTracking/GetIntegratedTrackingCustomers',
        params,
      );
      setData(prevData => [...prevData, ...response.data]);
      setAtualPage(prevPage => prevPage + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setAtualPage(0);
    setData([]);
    fetchAllCustomer();
  }, [ 
    byDate,
    initialPeriod,
    finalPeriod
  ]);

  const handleSearchByCustomer = async e => {
    e.preventDefault();
    setQueryParams(e.target.value);
    await debounceFilteredCustomers(e);
  };

  const fetchFilterCustomer = async e => {
    setLoading(true);
    try {
      const newParams = {
        ...params,
        page: 1,
        query: e.target.value.toLocaleLowerCase().trim(),
      };

      const response = await luftGet(
        '/IntegratedTracking/GetIntegratedTrackingCustomers',
        newParams,
      );
      setDataFilter(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const debounceFilteredCustomers = useCallback(debounce(fetchFilterCustomer, 1000), []);

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Number(item) !== Number(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, e.target.value]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    onApply(selectedItem);
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply([]);
  };

  const clearSearch = () => {
    setQueryParams('');
  };

  return (
    <NFFilter label="Destinatário" isOpen={isOpen} onClick={onClick}>
      <FilterForm
        label="Filtrar por cliente destinatário"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <InfinityContent
          inputSearchLabel="Buscar cliente"
          searchChange={handleSearchByCustomer}
          clearSearch={clearSearch}
          data={data}
          dataFiltered={dataFilter}
          fetchAllData={() => fetchAllCustomer()}
          hasMore={
            dataFilter.length !== 0
              ? dataFilter.length < totalLines
              : data.length < totalLines
          }
          queryParamas={queryParamas}
          loading={loading}
        >
          {(queryParamas ? dataFilter : data).map(filter => {
            if (filter.cnpjDest && filter.name) {
              return (
                <CheckboxControl
                  key={filter.cnpjDest}
                  value={filter.cnpjDest}
                  onChange={handleChange}
                  defaultChecked={selectedItem.some(
                    item => parseInt(item) === Number(filter.cnpjDest),
                  )}
                  title={filter.name}
                  description={cpfOrCnpjMask(filter.cnpjDest.trim())}
                  infinityList
                />
              )
            } 
          })}
        </InfinityContent>
      </FilterForm>
    </NFFilter>
  );
};

const mapStateToProps = state => ({
  listCustomers: state.tracking.filters.listCustomerTMS,
  initialPeriod: state.tracking.filters.initialPeriod,
  finalPeriod: state.tracking.filters.finalPeriod,
  byDate: state.tracking.filters.byDate,
});

export default connect(mapStateToProps)(Customers);
